export default __webpack_public_path__ + "static/media/logo512.10780aca.png";